import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/SouthAsiaLogo.png";
import EmailIcon from "../assets/images/Icon_Email.png";
import PhoneIcon from "../assets/images/Icon_Phone.png";
import InstagramLogo from "../assets/svg/InstagramLogo";
import FaceBookLogo from "../assets/svg/FaceBookLogo";
import TwiiterLogo from "../assets/svg/TwiiterLogo";
import LinkedinLogo from "../assets/svg/LinkedinLogo";

const Header = () => {
  return (
    <>
      <div className="header_topbar">
        <div className="container">
          <div className="header-top-strip">
            <p className="header-top-left">
              We help energy operations scale safely - Mumbai | Ahmedabad
            </p>
            <div className="header-top-right">
              <a
                href="https://www.facebook.com/SouthAsiaConsultancy/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="header-top-social"
              >
                <FaceBookLogo />
              </a>
              <a
                href="https://twitter.com/DSR_SOUTHASIA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="header-top-social"
              >
                <TwiiterLogo />
              </a>
              <a
                href="https://www.instagram.com/southasiaconsultancy"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="header-top-social"
              >
                <InstagramLogo />
              </a>
              <a
                href="https://www.linkedin.com/company/southasiaconsultancy/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="header-top-social"
              >
                <LinkedinLogo />
              </a>
            </div>
          </div>

          <div className="header-main-strip">
            <div className="header-brand-wrap">
              <Link to="/" className="header-brand-link">
                <img src={Logo} alt="South Asia Consultancy logo" className="img-fluid" />
                <div className="header-brand-copy">
                  <p className="header-logo-text">South Asia Consultancy</p>
                  <span className="header-brand-tagline">Operator-driven energy workforce partner</span>
                </div>
              </Link>
            </div>

            <div className="header-main-contact">
              <a href="mailto:info@southasiaconsultancy.com" className="header-contact-card">
                <img src={EmailIcon} alt="" />
                <span>
                  <small>Email Support</small>
                  info@southasiaconsultancy.com
                </span>
              </a>

              <a href="tel:+919316305258" className="header-contact-card">
                <img src={PhoneIcon} alt="" />
                <span>
                  <small>Call Support</small>
                  +91 9316305258
                </span>
              </a>

              <Link to="/contact" className="header-cta-btn">
                Get a Quote
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
